import React from 'react';
import cn from 'classnames';
import { Carousel } from 'antd';
import Layout from 'components/campus/layout';
import style from 'styles/campus/index.module.scss';
import UseResize from 'utils/hooks/useResize';

const IMG_PATH = 'https://devcdn.xylink.com/xylink_website_doc/images';
const environmentList = [
  {
    img: '/campus/pc/site-beijing2022.jpg',
    title: '北京',
  },
  {
    img: '/campus/pc/site-wuhan2022.jpg',
    title: '武汉',
  },
  {
    img: '/campus/pc/site-xian2022.jpg',
    title: '西安',
  },
  {
    img: '/campus/pc/site-zhengzhou2022.jpg',
    title: '郑州',
  },
  {
    img: '/campus/pc/site-shenzhen2022.jpg',
    title: '深圳',
  },
  {
    img: '/campus/pc/site-chengdu2022.jpg',
    title: '成都',
  },
];
const seniorList = [
  {
    img: '/campus/pc/senior_ZhouPeng.png',
    name: '周鹏-蛟龙一期',
    from: '西华大学19届\r\r软件工程专业',
    position: '研发部\r\r技术骨干',
    sendWord: '小鱼是一个充满活力、积极向上的团队。这里有着世界最前沿的音视频技术，有着与你共同快速成长的优秀伙伴，有着勇攀高峰和精益求精的精神，欢迎大家加入小鱼，成就更好的自己！',
  },
  {
    img: '/campus/pc/senior_NieHaiqing.png',
    name: '聂海情-蛟龙一期',
    from: '华北电力大学19届\r\r电子信息科学与技术 ',
    position: '测试部\r\r测试骨干',
    sendWord: '小鱼是一个开放自由的平台，这里有一对一的导师悉心指导，助你上好“职场第一课”；这里有并肩作战的兄弟，一同砥砺前进，披荆斩棘；金麟岂是池中物，一遇风云便化龙，加入我们一起共创精彩！',
  },
  {
    img: '/campus/pc/senior_GuoShihao.png',
    name: '郭世豪-蛟龙二期',
    from: '华北科技学院20届\r\r电子信息工程专业',
    position: '技术架构部\r\r架构师',
    sendWord: '工作中前辈们的淳淳教导，同事间的相互鼓励，以及丰富的团建娱乐，打破了我对职场固有的认知，原来工作也可以这么有趣！非常荣幸成为小鱼大家庭中的一员，欢迎加入我们！',
  },
  {
    img: '/campus/pc/senior_Wangjin.png',
    name: '王锦-蛟龙二期',
    from: '西安财经大学20届\r\r计算机科学与技术专业',
    position: '研发部\r\r研发工程师',
    sendWord: '小鱼是一个拥有独特风格和企业文化的公司，团队氛围很好，员工对自己负责的业务尽职尽责。团队分工明确，对于技术问题充满好奇心，好奇心才会让小鱼走的更高、更远。很荣幸成为“小鱼人”。',
  },
  {
    img: '/campus/pc/senior_WuYitong.png',
    name: '武一彤-蛟龙三期',
    from: '西南交通大学21届\r\r统计学专业',
    position: '营销部\r\r销售管培生',
    sendWord: '小鱼是云视频行业的领军企业，在这里有广阔的平台，完善的培养制度，还有导师一对一指导，帮助我们从学生向职场人迅速转变。期待有理想的你加入小鱼，在这里发挥无限的潜力！',
  },
  {
    img: '/campus/pc/senior_WangSiqing.png',
    name: '王思琴-蛟龙三期',
    from: '北京交通大学21届\r\r电子与通信工程专业',
    position: '产品部\r\r产品经理',
    sendWord: '小鱼是一家企业，更是一个大家庭。全面而专业的入职培训，一对一的导师指导，让我快速适应并融入，明确了自己前行的方向。在这里我们有共同目标，一起努力、学习、成长，充实而快乐！',
  },
];
const team = [
  {
    img: '/campus/pc/last-campus-05.jpg',
    title: '蛟龙一期团建',
  },
  {
    img: '/campus/pc/last-campus-01.jpg',
    title: '蛟龙一期培训',
  },
  {
    img: '/campus/pc/last-campus-02.jpg',
    title: '蛟龙二期团建',
  },
  {
    img: '/campus/pc/last-campus-03.jpg',
    title: '蛟龙二期培训',
  },
  {
    img: '/campus/pc/last-campus-06.jpg',
    title: '蛟龙三期团建',
  },
  {
    img: '/campus/pc/last-campus-07.jpg',
    title: '蛟龙三期培训',
  },
];
const Campus2022 = () => {
  const size = UseResize();
  return (
    <Layout pageKey="home">
      <section className={style.banner2}>
        <div className={style.content}>
          <p>想参与运营商级专业云平台的设计与开发？</p>
          <p>想成为受人膜拜业界顶尖的音视频算法大牛？</p>
          <p>想了解全球部署的视讯云架构是如何搭建的？</p>
          <p className={'for-pc'}>想选择5G时代下最具成长力的云视频独角兽企业开疆拓土？</p>
          <p className={'for-mobile'}>
            想选择5G时代下最具成长力的云视频独角兽企业 <br />
            开疆拓土？
          </p>
          <br />
          <p className={'for-pc'}>这一切都不再遥不可及，现在就请关注小鱼易连“蛟龙计划2022”，</p>
          <p className={cn(style.start, 'for-mobile')}>
            这一切都不再遥不可及， <br />
            现在就请关注小鱼易连“蛟龙计划2022”，
          </p>
          <p className={'for-mobile'}>
            面向全国多所重点院校的校园招聘活动 <br />
            已经全面启动啦！!
          </p>
          <p className={'for-pc'}>面向全国多所重点院校的校园招聘活动已经全面启动啦！!</p>
          <p className={'for-pc'}>培育千名行业精英，只要你肯来，机会就在你的手上！</p>
          <p className={'for-mobile'}>
            培育千名行业精英，
            <br />
            只要你肯来，机会就在你的手上！
          </p>
          <a href="https://xylink.zhiye.com/campus" className={style.btn}>
            立即申请
          </a>
        </div>
      </section>
      <section className={style.banner3}>
        <div className={style.content}>
          <p className={style.title}>小鱼易连是一家怎样的公司？</p>
          <p className={style.desc}>
            小鱼易连是中国领先的高品质云视频专家，拥有大规模云计算和音视频的核心自主知识产权，以及全场景视频终端，面向政府、教育、医疗等机构和各行业企业，提供全网络环境下超高清、低延时、安全、可靠的一站式云视频解决方案。小鱼易连目前已经深入到政务、教育、保险、银行、医疗、制造、石油、电力、建筑、高科技电子等领域，服务于十万多家客户，其中包括三十多家中央企业和国家部委，以及上百家省市政府机构，是“新基建产业独角兽、云视频会议行业领军企业、中国科创企业百强、智慧司法十大解决方案提供商”，连续两年在中国网络会议市场的占有率排名首位。
          </p>
        </div>
      </section>
      <section className={style.banner4}>
        <div className={style.content}>
          <div className={style.title}>什么是 “蛟龙计划” ？</div>
          <p>“蛟龙计划”是小鱼易连推出的面向高校应届生招聘的特殊人才培养计划，培育千名未来的业界精英！</p>
          <p>入职：内部导师一对一培养与职业规划制定；</p>
          <p>转正：可在导师指导下自主选择工作岗位，并可在北京总部及各地分公司定期进行交流学习；</p>
          <p>工作满两年：经过考核与评估，可晋升骨干或经理职级。</p>
          <p>蛟龙计划已圆满完成三期人才培养，蛟龙四期欢迎您的加入！</p>
          <a href="https://xylink.zhiye.com/campus" className={style.btn}>
            立即申请
          </a>
        </div>
      </section>
      <section className={cn(style.banner3, style.banner5)}>
        <div className={style.content}>
          <p className={style.title}>你能够在这里获得什么？</p>
          <p className={style.desc}>
            刚刚走出校园的学生，就像一张充满无限遐想的白纸，可以画出最美的图画。你可能不具备丰富的工作经验，也缺少专业的知识技能，但只要你有信心、肯努力、爱钻研、求上进，你就可以成为小鱼的一员，加入到即将到来的云视讯大潮中，做一名激流勇进的冲浪者。这里有音视频专家手把手指导，也有资深架构师随时沟通讨论，更有专业的销售大牛引路入门。答疑解惑后，在实际的产品或项目中动手实践，让自己快速成长。
          </p>
        </div>
      </section>
      <section className={cn(style.banner4, style.banner6)}>
        <div className={style.content}>
          <div className={style.title}>员工福利</div>
          <div className={style.step}>
            <div className={style.item}>
              <img src="/v2/images/campus/airplane.png" alt="" className={style['item-icon']} />
              <img src="/v2/images/campus/line1.png" alt="" className={cn(style.line, 'for-pc')} />
              <p>五险一金</p>
              <p>带薪休假、年度体检</p>
            </div>
            <div className={style.item}>
              <img src="/v2/images/campus/rest.png" alt="" className={style['item-icon']} />
              <img src="/v2/images/campus/line2.png" alt="" className={cn(style.line, 'for-pc')} />
              <p>餐补</p>
              <p>下午茶、水果零食</p>
            </div>
            <div className={style.item}>
              <img src="/v2/images/campus/collect.png" alt="" className={style['item-icon']} />
              <img src="/v2/images/campus/line3.png" alt="" className={cn(style.line, 'for-pc')} />
              <p>结婚、生子礼金</p>
              <p>节日福利</p>
            </div>
            <div className={style.item}>
              <img src="/v2/images/campus/sport.png" alt="" className={style['item-icon']} />
              <div></div>
              <p>健身活动、游泳</p>
              <p>足球、篮球等俱乐部</p>
            </div>
          </div>
        </div>
      </section>
      <section className={cn(style.banner3, style.banner7)}>
        <div className={style.content}>
          <p className={style.title}>公司荣誉</p>
          <div className={style.desc}>
            <p>国际权威数据机构</p>
            <p>IDC最新年度报告 中国网络会议市场占有率第一</p>
            <p>中国企业家 &nbsp;中国科创企业百强</p>
            <p>36Kr &nbsp;2020最佳协同办公解决方案奖</p>
            <p>i黑马 &nbsp;2020“新基建”产业独角兽TOP100</p>
            <p>Gartner &nbsp;2019 Cool Vendors</p>
            <p>......</p>
          </div>
        </div>
      </section>
      <section className={cn(style.banner4, style.banner8)}>
        <div className={style.content}>
          <div className={cn(style.title, 'for-pc')}>工作环境</div>
          <div className={cn(style.title, 'for-mobile')}>办公环境</div>
          <Carousel autoplay dots={false} slidesToShow={size.width > 767 ? 2 : 1} slidesToScroll={1}>
            {environmentList.map(item => {
              return (
                <div key={item.title} className={style['environment-item']}>
                  <img src={IMG_PATH + item.img} alt="" />
                  <p>{item.title}</p>
                </div>
              );
            })}
          </Carousel>
        </div>
      </section>
      <section className={cn(style.banner3, style.banner9)}>
        <div className={style.content}>
          <p className={style.title}>“蛟龙计划”学员说</p>
          <Carousel autoplay dots={false} slidesToShow={2} slidesToScroll={1} className={'for-pc'}>
            {seniorList.map(item => {
              return (
                <div key={item.name} className={style['senior-item']}>
                  <img src={IMG_PATH + item.img} alt="" />
                  <div className={style.introduce}>
                    <p className={style.name}>{item.name}</p>
                    <p className={style.from} dangerouslySetInnerHTML={{ __html: item.from.replace(/\r/g, '&nbsp;') }}></p>
                    <p className={style.from} dangerouslySetInnerHTML={{ __html: item.position.replace(/\r/g, '&nbsp;') }}></p>
                    <p className={style.sendWord}>{item.sendWord}</p>
                  </div>
                </div>
              );
            })}
          </Carousel>
          <div className={'for-mobile'}>
            {seniorList.map(item => {
              return (
                <div key={item.name} className={style['senior-item']}>
                  <img src={IMG_PATH + item.img} alt="" />
                  <div className={style.introduce}>
                    <p className={style.name}>{item.name}</p>
                    <p className={style.from} dangerouslySetInnerHTML={{ __html: item.from.replace(/\r/g, '&nbsp;') }}></p>
                    <p className={style.position} dangerouslySetInnerHTML={{ __html: item.position.replace(/\r/g, '&nbsp;') }}></p>
                    <p className={style.sendWord}>{item.sendWord}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className={cn(style.banner4, style.banner8)}>
        <div className={style.content}>
          <div className={style.title}>“蛟龙计划”学员风采</div>
          <Carousel autoplay dots={false} slidesToShow={size.width > 767 ? 2 : 1} slidesToScroll={1}>
            {team.map(item => {
              return (
                <div key={item.title} className={style['environment-item']}>
                  <img src={IMG_PATH + item.img} alt="" />
                  <p>{item.title}</p>
                </div>
              );
            })}
          </Carousel>
        </div>
      </section>
      <section className={cn(style.banner3, style.banner10)}>
        <div className={style.content}>
          <div className={style.title}>申请职位</div>
          <p>申请职位时需添加简历附件</p>
          <p>简历标题格式：期望工作地+姓名+职位，如: “成都+王晓瑜+Java开发工程师”</p>
          <div className={style.btnS}>
            <a href="https://xylink.zhiye.com/campus" className={style.btn}>
              立即申请
            </a>
            <a href="/" className={cn(style.btn, style.goHome)}>
              访问小鱼官网首页
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Campus2022;
